// extracted by mini-css-extract-plugin
export default {"p_content":"e5adcfe7cf"};